import { Component, OnInit } from '@angular/core';
import { AppPreviousrouterservice } from '../app.previousrouterservice';
import {ActivatedRoute, NavigationStart, Router} from '@angular/router';
import {AppService} from '../app.service';
import {LocalStorageService, SessionStorageService} from 'angular-web-storage';
import {DomSanitizer} from '@angular/platform-browser';
import {environment} from '../../environments/environment';
import {forEach} from '@angular/router/src/utils/collection';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-singleapp',
  templateUrl: './singleapp.component.html',
  styleUrls: ['./singleapp.component.scss']
})
export class SingleappComponent implements OnInit {

  previousUrl: string;
  currentUrl: string;
  appId;
  appData: any;
  appDesc: any;
  appIdChange: number;

  userCredential: any;
  accessPrivileges: any;
  downloadCount: any;
  backButtonAppend: string;

  userInstalled: number;
  appImageList: any;
  appImageListAll: any = new Array();
  appImagesLength: number;

  constructor(
    private router: Router,
    private previousRouteService: AppPreviousrouterservice,
    private _appService: AppService,
    private sessionStorage: SessionStorageService,
    private localStorage: LocalStorageService,
    private _route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {

    this.spinner.show();
    this.userCredential = this.localStorage.get('sociaKey');

    if (this.sessionStorage.get('accessPrivileges')) {
      this.accessPrivileges = this.sessionStorage.get('accessPrivileges');
    } else {
      this.accessPrivileges = this.sessionStorage.set('accessPrivileges', environment.appPrivilege);
    }

    const appId = this._route.snapshot.params.appid;
    this.appIdChange = appId;

    this.currentUrl = this.router.url;
    this.previousUrl = this.previousRouteService.getPreviousUrl();


    if (this.previousUrl === '/themes') {
      this.backButtonAppend = '/1';
    } else if (this.previousUrl === '/home') {
      this.backButtonAppend = '/2';
    } else {
      this.backButtonAppend = '';
    }

    if (this.currentUrl === this.previousUrl) {
      this.previousUrl = '/home';
      this.backButtonAppend = '/2';
    }

    this._route.params.forEach((params: any) => {
      console.log(params['appid']);
      if (params['redirection'] && params['redirection'] !== '') {
        const redirection = params['redirection'];
        if (redirection === '2') {
          this.previousUrl = '/home';
          this.backButtonAppend = '/2';
        } else if (redirection === '1') {
          this.previousUrl = '/themes';
          this.backButtonAppend = '/1';
        }
      }
    });

    this._appService.getAppImages(appId).subscribe(imageData => {
      this.appImagesLength = imageData['length'];

      this.appImageList = imageData;
      this.appImageList.forEach(imgData => {
        this.appImageListAll.push(imgData.app_img_url);
      });

      this.spinner.hide();

    });

    this._appService.getAppByAppID(appId).subscribe(data => {
      this.appDesc = this.sanitizer.bypassSecurityTrustHtml(data['app_desc']);
      this.appData = data;
    });

    this._appService.getDownloadCount(appId).subscribe(resDownload => {
      this.downloadCount = resDownload['downloadcount'];
    });

    const userIdentifier = window.navigator.userAgent.replace(/\D+/g, '');

    let userEmail = '';
    if (this.userCredential) {
      userEmail = this.userCredential.userEmail;
    } else {
      userEmail = userIdentifier;
    }

    this._appService.getUserInstalledAppByAppID(userEmail, userIdentifier, appId).subscribe(dataDownload => {
      if (dataDownload) {
        this.userInstalled = dataDownload['installed'];
      } else {
        this.userInstalled = 0;
      }

      this.spinner.hide();
    });

  }

  clickAppDownload(appId: number) {

    this.spinner.show();
    let userEmail = null;

    const userIdentifier = window.navigator.userAgent.replace(/\D+/g, '');

    if (this.userCredential) {
      userEmail = this.userCredential.userEmail;
    } else {
      userEmail = userIdentifier;
    }

    this._appService.addDownloadClick(userEmail, appId, userIdentifier).subscribe(res => {
      console.log(res);
      this.spinner.hide();
    });
  }

}
